<template>
  <router-view />
</template>

<script>
export default {
  name: 'System'
}
</script>

<style>

</style>
